import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { MAINTENANCE_MODE } from '../../config';

/**
 * MaintenanceGuard - Redirects to maintenance page when MAINTENANCE_MODE is enabled
 * 
 * Usage:
 * - Wrap routes that should be protected during maintenance
 * - The /maintenance route itself should NOT be wrapped to avoid infinite redirects
 * - Set REACT_APP_MAINTENANCE_MODE=true in .env to enable maintenance mode
 */
export default function MaintenanceGuard({ children }) {
  const location = useLocation();
  
  // If maintenance mode is enabled and we're not already on the maintenance page
  if (MAINTENANCE_MODE && location.pathname !== '/maintenance') {
    console.log('🔧 Maintenance mode enabled - redirecting to maintenance page');
    return <Navigate to="/maintenance" replace />;
  }
  
  // If maintenance mode is disabled and we're on the maintenance page, redirect to home
  if (!MAINTENANCE_MODE && location.pathname === '/maintenance') {
    console.log('✅ Maintenance mode disabled - redirecting to home');
    return <Navigate to="/" replace />;
  }
  
  // Normal operation - render children
  return <>{children}</>;
}
